import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { useState } from 'react';
import { Button, Flex, HeaderItalic } from '@/components/common';
import { AccountSubpageShell } from '@/components/layout';
import { useCurrentUser } from '@/contexts';
import { analyticsClient } from '@/lib';
import { userService } from '@/services/userService';
import { SpotsPicker } from '@/views/onboarding/SpotsPicker';

export function EditSpotsPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('profile');
  const { currentUser: profile } = useCurrentUser();
  const [spots, setSpots] = useState<string[]>(() => profile?.spots ?? []);
  const [saving, setSaving] = useState(false);

  if (!profile) return null;

  const handleSave = async () => {
    setSaving(true);
    try {
      await userService.updateProfile(profile.uid, { spots });
      analyticsClient.capture('spots_updated', { spot_count: spots.length });
      toast.success(t('edit.saveSuccess'));
      navigate('/account/my-profile/edit');
    } catch (err) {
      console.error(err);
      toast.error(t('edit.errors.saveFailed'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <AccountSubpageShell
      onBack={() => navigate('/account/my-profile/edit')}
      right={
        <Button
          type="button"
          variant="outline"
          color="gray"
          highContrast
          radius="full"
          size="sm"
          fullWidth={false}
          disabled={saving}
          isLoading={saving}
          onClick={() => void handleSave()}
        >
          {t('edit.actions.save')}
        </Button>
      }
    >
      <Flex direction="column" gap="4" py="2" pb="5">
        <HeaderItalic>{t('edit.spotsTitle')}</HeaderItalic>
        <SpotsPicker value={spots} onChange={setSpots} />
      </Flex>
    </AccountSubpageShell>
  );
}
